import DashboardApi from '../api/ServiceApi';
import MockDashboardApi from './mockDashboardApi';

const api = process.env.NODE_ENV === "development" ? MockDashboardApi : DashboardApi;
export default DashboardApi;


// WEBPACK FOOTER //
// ./src/dashboard/api.js